/**
 * L'ADRESSE COMPLÈTE DE L'ÉCRAN AFFICHÉ — chemin ET paramètres.
 *
 * Le routeur ne suit que le CHEMIN (`currentPath`) : un écran qui écrit son
 * état dans l'adresse (`remplacerRecherche`, `?onglet=caisses`) le fait sans
 * le prévenir, exprès — un filtre n'est pas une navigation. Mais quand une
 * garde refuse un Retour, le routeur REMET l'adresse quittée : avec le seul
 * chemin, `?onglet=caisses` disparaissait de la barre d'adresse alors que
 * l'écran montrait toujours l'onglet, et un F5 rouvrait le premier (revue du
 * 07/10/2026). Les deux côtés notent donc ici l'adresse COMPLÈTE : le routeur
 * à chaque navigation, `remplacerRecherche` à chaque réécriture.
 *
 * ═══ QUI L'ÉCOUTE (sous-familles de la Comptabilité, 07/10/2026) ═══
 * La barre latérale. Ses fonctions peuvent désigner une VUE d'une page
 * (`/comptabilite/clotures?vue=ecarts`) : passer de « Écarts » à
 * « Historique » dans la liste ne change que le paramètre, sans navigation,
 * et l'élément actif du menu restait sur « Écarts ». Elle s'abonne donc ici
 * (`use-adresse-courante.ts`) plutôt qu'au chemin du routeur. Ce n'est PAS
 * une navigation : rien ne défile, rien ne se recharge, aucun titre ne change.
 *
 * Module sans `window` ni React au chargement : `adresse-ecran.ts` se teste
 * hors navigateur, et le routeur, lui, touche `window` dès son import.
 */
let notee: string | null = null
const abonnes = new Set<() => void>()

export function noterAdresse(url: string): void {
  if (url === notee) return
  notee = url
  for (const abonne of abonnes) abonne()
}

/** La dernière adresse notée ; `null` avant la première navigation. */
export function adresseNotee(): string | null {
  return notee
}

/** Être prévenu de chaque adresse notée ; rend de quoi se désabonner. */
export function abonnerAdresse(abonne: () => void): () => void {
  abonnes.add(abonne)
  return () => { abonnes.delete(abonne) }
}
